module.exports = __webpack_public_path__ + "static/media/login-background.3df7a551.png";